export default {
  "content": "<path d=\"M20.83 29.767l-.01-.006c-2.058-1.28-4.901-.801-6.891.997-.613.554-1.483.806-2.089.43L10 30.042c3.202-4.462 9.085-6.035 13.14-3.514l.01.006-2.32 3.232z\" fill=\"#AF64FF\"/><path d=\"M11.355 4.521l.012-.003.172.4c5.075-1.206 10.647 1.553 12.557 6.271l-2.338.63c-.77.207-1.615-.22-2.086-.866-1.53-2.098-4.404-3.181-7.02-2.477l-.012.004-.111-.275C7.671 9.193 2.155 6.195.059 1.358l2.246-.56c.739-.184 1.585.282 2.078.955 1.602 2.19 4.46 3.394 6.972 2.768z\" fill=\"#00ECBB\"/>",
  "attrs": {
    "width": "25",
    "height": "35",
    "viewBox": "0 0 25 35",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};